/**
 * `ColumnDef` list for the Item Models table: model code link · name · type
 * (equipment/component) · category · active status. Built on the shared masters
 * status renderers + `TableLink`.
 */
import type { ColumnDef } from '@vnetwork/ui/data';
import type { ItemModel } from '@/api/capacities';
import { TableLink } from '@/components/table-link';
import { activeStatusCell, itemTypeCell } from '../../shared/masters-status';

const muted = { color: 'var(--vn-fg-muted)', fontStyle: 'italic' } as const;

export const modelColumns: ColumnDef<ItemModel, unknown>[] = [
  {
    id: 'model',
    header: 'Model',
    cell: ({ row }) => (
      <TableLink to={`/capacities/models/${row.original.id}`} title={row.original.model}>
        {row.original.model || row.original.id}
      </TableLink>
    ),
  },
  {
    id: 'name',
    header: 'Name',
    cell: ({ row }) => (
      <span title={row.original.name} style={{ overflowWrap: 'anywhere' }}>
        {row.original.name}
      </span>
    ),
  },
  {
    id: 'item_type',
    header: 'Type',
    cell: ({ row }) => itemTypeCell(row.original.item_type),
  },
  {
    id: 'category',
    header: 'Category',
    cell: ({ row }) =>
      row.original.category ? row.original.category : <span style={muted}>—</span>,
  },
  {
    id: 'is_active',
    header: 'Status',
    cell: ({ row }) => activeStatusCell(row.original.is_active),
  },
];
